import repostRepository from "@/services/api/repostRepository";
import postWatchRepository from "@/services/api/postWatchRepository";
import historyRepository from "@/services/api/historyRepository";
import monitoredSubRepository from "@/services/api/monitoredSubRepository";
import postRepository from "@/services/api/postRepository";
import memeTemplateRepository from "@/services/api/memeTemplateRepository";
import statsRepository from "@/services/api/statsRepository";
import messageTemplateRepository from "@/services/api/messageTemplateRepository";
import adminRepository from "@/services/api/adminRepository";
import userWhitelistRepository from "@/services/api/userWhitelistRepository";

const repositories = {
    repost: repostRepository,
    watch: postWatchRepository,
    history: historyRepository,
    monitored: monitoredSubRepository,
    post: postRepository,
    meme: memeTemplateRepository,
    stats: statsRepository,
    messageTemplate: messageTemplateRepository,
    admin: adminRepository,
    userWhitelist: userWhitelistRepository
};

export const RepositoryFactory = {
    get: name => repositories[name],
};
